export type TMerchantWebhookSettings = {
	notify?: string;
	redirect_on_fail?: string;
	redirect_on_success?: string;
};

const UNMASKED_WEBHOOK_HOSTNAME = "cabinet.impaya.com";
const EMPTY_WEBHOOK_URL = "---";
const webhookUrlFields: (keyof TMerchantWebhookSettings)[] = ["notify", "redirect_on_fail", "redirect_on_success"];

const isObjectRecord = (value: unknown): value is Record<string, unknown> => !!value && typeof value === "object" && !Array.isArray(value);

export const shouldTransformWebhookDisplay = (hostname = typeof window === "undefined" ? "" : window.location.hostname) =>
	hostname.toLowerCase() !== UNMASKED_WEBHOOK_HOSTNAME;

export const getWebhookDisplayUrl = (sourceUrl: string | undefined, merchantNotifyUrl: string | undefined) =>
	shouldTransformWebhookDisplay() ? merchantNotifyUrl : sourceUrl;

export const getWebhookForDisplay = <T extends { url?: string }>(webhook: T, merchantNotifyUrl: string | undefined): T => ({
	...webhook,
	url: getWebhookDisplayUrl(webhook.url, merchantNotifyUrl) || EMPTY_WEBHOOK_URL,
});

export const getRawDataForDisplay = (data: unknown, merchantWebhooks?: TMerchantWebhookSettings): unknown => {
	if (!isObjectRecord(data)) return data;

	const visibleData = structuredClone(data) as Record<string, unknown>;
	if (!shouldTransformWebhookDisplay()) return visibleData;

	const request = isObjectRecord(visibleData.req) ? visibleData.req : visibleData;
	delete request.urls;

	const merchant = isObjectRecord(request.merchant) ? request.merchant : undefined;
	const settings = merchant && isObjectRecord(merchant.settings) ? merchant.settings : undefined;
	const credentials = settings && isObjectRecord(settings.credentials) ? settings.credentials : undefined;
	const webhooks = credentials && isObjectRecord(credentials.webhooks) ? credentials.webhooks : undefined;
	if (!webhooks) return visibleData;

	for (const field of webhookUrlFields) {
		if (Object.prototype.hasOwnProperty.call(webhooks, field)) webhooks[field] = merchantWebhooks?.[field] || EMPTY_WEBHOOK_URL;
	}

	return visibleData;
};
